export default __webpack_public_path__ + "assets/images/button-almost-bad.350f051e5bfd64b449690ba5dcfc4513.svg";